export default __webpack_public_path__ + "static/techguru-example9-ff931ec2e1e7eb4553ea9de61f4bf80d.jpg";